// EDIT THIS FILE to set your payment handles.
// Leave any field empty ("") to hide that option in the donate modal.
//
// ANONYMITY GUIDE:
//   Cash App  — shows only your $cashtag (choose any pseudonym)         ✅ anonymous-friendly
//   Ko-fi     — shows any display name you pick on ko-fi.com            ✅ anonymous-friendly
//   BMC       — shows any display name you pick on buymeacoffee.com     ✅ anonymous-friendly
//   Venmo     — shows your legal first name + last initial              ❌ NOT anonymous
//   Zelle     — shows your full legal name                              ❌ NOT anonymous
//   PayPal    — shows your name unless you use a business PayPal        ⚠️ medium
//
// Defaults below prioritize anonymity. Enable Venmo/Zelle/PayPal only if you're OK with your name being visible to donors.

export const DONATE_CONFIG = {
  suggested: 20,
  tiers: [1, 5, 10, 20, 50, 100, 250, 500, 1000, 5000, 10000, 50000],

  // Anonymous-friendly (recommended):
  cashapp: "",                   // DISABLED — user chose BMC + Ko-fi only for cleanest anonymity
  kofi: "sAImonSays",            // ko-fi.com/sAImonSays
  bmc: "sAImonSays",             // buymeacoffee.com/sAImonSays

  // NOT anonymous — enable ONLY if you don't mind your name being visible:
  venmo: "",                     // Your Venmo username (without @)
  zelle: "",                     // Email or phone tied to your Zelle
  paypal: "",                    // Your PayPal.me slug — use a Business PayPal to hide name

  // How often the gentle nudge shows non-donors (in page views). 1 = every page.
  nudgeEveryPageViews: 1,

  // Hosting + Ops Fund transparency
  hosting: {
    show: true,
    monthlyCostUsd: 45,          // Estimated monthly hosting + AI credits
    receivedThisMonthUsd: 0,     // Update manually as donations arrive
  },

  // Ops Fund — where donations SHOULD be allocated for sustainability.
  // Transparency-only. You still move the money manually.
  opsFund: {
    show: true,
    // Percentages must sum to <= 100
    hostingPct: 5,               // Servers / DB / bandwidth
    securityPct: 2,              // Backups, monitoring, DDoS
    promotionPct: 3,             // Ads, sharing incentives
    // Remaining (100 - sum above) goes to the creator (you)
  },
};

export const buildLinks = (amount) => {
  const amt = Math.max(1, Math.floor(Number(amount) || DONATE_CONFIG.suggested));
  const note = encodeURIComponent(`sAimonSays.Ai donation — thank you!`);
  const links = [];

  // Ordered: anonymous-friendly first
  if (DONATE_CONFIG.cashapp) {
    links.push({
      id: "cashapp", label: "Cash App",
      handle: `$${DONATE_CONFIG.cashapp}`,
      url: `https://cash.app/$${DONATE_CONFIG.cashapp}/${amt}`,
      anon: true,
    });
  }
  if (DONATE_CONFIG.kofi) {
    links.push({
      id: "kofi", label: "Ko-fi",
      handle: `ko-fi.com/${DONATE_CONFIG.kofi}`,
      url: `https://ko-fi.com/${DONATE_CONFIG.kofi}`,
      anon: true,
    });
  }
  if (DONATE_CONFIG.bmc) {
    links.push({
      id: "bmc", label: "Buy Me a Coffee",
      handle: `buymeacoffee.com/${DONATE_CONFIG.bmc}`,
      url: `https://buymeacoffee.com/${DONATE_CONFIG.bmc}`,
      anon: true,
    });
  }
  if (DONATE_CONFIG.venmo) {
    links.push({
      id: "venmo", label: "Venmo",
      handle: `@${DONATE_CONFIG.venmo}`,
      url: `https://venmo.com/${DONATE_CONFIG.venmo}?txn=pay&amount=${amt}&note=${note}`,
      anon: false,
    });
  }
  if (DONATE_CONFIG.paypal) {
    links.push({
      id: "paypal", label: "PayPal",
      handle: `paypal.me/${DONATE_CONFIG.paypal}`,
      url: `https://paypal.me/${DONATE_CONFIG.paypal}/${amt}`,
      anon: false,
    });
  }
  if (DONATE_CONFIG.zelle) {
    links.push({
      id: "zelle", label: "Zelle",
      handle: DONATE_CONFIG.zelle,
      url: null,
      anon: false,
    });
  }
  return links;
};
